webpackJsonp([34879551326373],{

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background-color: rgba(255, 255, 255, .4);\n  box-shadow: 0px 0px 2px 1px rgba(0,0,0,0.3);\n  padding: 1rem;\n  margin-bottom: 2rem;\n  h1 {\n    margin-top: .5rem;\n  }\n  h4 {\n    margin-top: 1rem;\n  }\n"], ["\n  background-color: rgba(255, 255, 255, .4);\n  box-shadow: 0px 0px 2px 1px rgba(0,0,0,0.3);\n  padding: 1rem;\n  margin-bottom: 2rem;\n  h1 {\n    margin-top: .5rem;\n  }\n  h4 {\n    margin-top: 1rem;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(18);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(49);
	
	var _gatsbyImage = __webpack_require__(829);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _date = __webpack_require__(73);
	
	var _ContentGrid = __webpack_require__(52);
	
	var _ContentGrid2 = _interopRequireDefault(_ContentGrid);
	
	var _ContentGridMain = __webpack_require__(53);
	
	var _ContentGridMain2 = _interopRequireDefault(_ContentGridMain);
	
	var _PostImage = __webpack_require__(72);
	
	var _PostImage2 = _interopRequireDefault(_PostImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var NoteWrapper = _styledComponents2.default.div(_templateObject);
	
	var Note = function (_React$Component) {
	  _inherits(Note, _React$Component);
	
	  function Note() {
	    _classCallCheck(this, Note);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Note.prototype.componentDidMount = function componentDidMount() {
	    // Ensure that twitter embeds load.
	    setTimeout(function () {
	      if (typeof twttr !== "undefined" && window.twttr.widgets && typeof window.twttr.widgets.load === "function") {
	        window.twttr.widgets.load();
	      }
	    }, 0);
	  };
	
	  Note.prototype.render = function render() {
	    var post = this.props.data.nodePost;
	    var formattedDate = (0, _date.formatDate)(post.created);
	    return _react2.default.createElement(
	      _ContentGrid2.default,
	      null,
	      _react2.default.createElement(
	        _ContentGridMain2.default,
	        null,
	        _react2.default.createElement(
	          NoteWrapper,
	          null,
	          _react2.default.createElement(
	            _reactHelmet.Helmet,
	            null,
	            _react2.default.createElement(
	              "title",
	              null,
	              post.title,
	              " | Brian Perry"
	            )
	          ),
	          _react2.default.createElement(
	            "h4",
	            null,
	            "\u2014 ",
	            formattedDate
	          ),
	          post.relationships.image ? _react2.default.createElement(_PostImage2.default, { sizes: post.relationships.image.localFile.childImageSharp.sizes }) : null,
	          _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: post.body.value } })
	        )
	      )
	    );
	  };
	
	  return Note;
	}(_react2.default.Component);
	
	exports.default = Note;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-note-js-04822a892a36a71e63a5.js